import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const ChairmanMessage = () => {
  const messageRef = useRef(null);
  const imageRef = useRef(null);

  useEffect(() => {
    gsap.fromTo(
      messageRef.current,
      { x: -100, opacity: 0 },
      {
        x: 0,
        opacity: 1,
        duration: 1.2,
        scrollTrigger: {
          trigger: messageRef.current,
          start: "top 80%",
        },
      }
    );

    gsap.fromTo(
      imageRef.current,
      { x: 100, opacity: 0 },
      {
        x: 0,
        opacity: 1,
        duration: 1.2,
        scrollTrigger: {
          trigger: imageRef.current,
          start: "top 80%",
        },
      }
    );
  }, []);

  return (
    <div className="bg-white text-black py-20 px-6 lg:px-20">
      <div className="flex flex-col lg:flex-row items-center gap-12 max-w-7xl mx-auto">
        {/* Left Side - Message */}
        <div ref={messageRef} className="lg:w-2/3">
          <h2 className="text-3xl md:text-4xl font-bold text-yellow-600 mb-6">
            Message from the Founder & Chairman
          </h2>
          <p className="text-gray-500 mb-4">
            Dear Valued Clients, Partners, Team and Friends,
          </p>
          <p className="text-gray-400 mb-4">
            It gives me great pride and gratitude to address you as the Founder and Chairman of <span className="text-yellow-500 font-semibold">SpanBucks Developers and Builders Private Limited</span>.
            This company was built on three simple but powerful principles: <span className="text-yellow-500 font-semibold">Trust, Invest and Prosper</span> — as real estate is more than just land and buildings; it's about creating spaces where people live, grow and build their futures.
          </p>
          <p className="text-gray-400 mb-4">
            Trust is the cornerstone of everything we do — from our relationships with clients and partners to the way we approach every project.
            We believe that trust is earned through transparency, consistency, and delivering on our promises.
          </p>
          <p className="text-gray-400 mb-4">
            We encourage our clients to invest not only in property, but in a future that holds value — financially, personally, and socially.
            Every development we create is an opportunity for long-term growth and a reflection of our commitment to excellence.
          </p>
          <p className="text-gray-400 mb-4">
            And finally, we strive for all who walk this journey with us to prosper — because real success lies in shared progress.
            Whether you're a first-time buyer, a seasoned investor, or a business partner, your success is a part of ours.
          </p>
          <p className="text-gray-400 mb-4">
            At SpanBucks, we’re not just shaping skylines — we’re building legacies.
            Thank you for visiting us — we look forward to building the future, together.
          </p>

          <div className="mt-6">
            <p className="font-semibold text-yellow-500">Warm regards,</p>
            <p className="text-gray-700">Srikanth Reddy Patlolla</p>
            <p className="text-gray-400">Founder & Chairman</p>
            <p className="text-gray-400">SpanBucks Developers and Builders Private Limited</p>
          </div>
        </div>

        {/* Right Side - Image */}
        <div ref={imageRef} className="lg:w-1/3 w-full">
          <img
            src="./chairman.jpeg"
            alt="Founder"
            className="rounded-xl shadow-lg object-cover w-full h-[500px]"
          />
        </div>
      </div>
    </div>
  );
};

export default ChairmanMessage;
